interface Props {
  children: React.ReactNode
  className?: string
}

export default function SectionContainer({ children, className = '' }: Props): React.ReactElement {
  return <div className={`max-w-320 mx-auto w-full px-4 md:px-20 ${className}`}>{children}</div>
}
